<template>
    <v-col cols="12" md="3" ma-1
        v-if="hotel && hotel.bookable_via_iescape"
    >
        <v-card>
            <v-card-title class="title font-weight-black">
                <v-icon class="pr-3">home</v-icon>Manage Inventory 
            </v-card-title>

            <v-card-text>
                <v-container fluid>
                    <v-row>
                        <v-col>
                            <v-btn v-if="!isTailormadeTour" class="mt-1" block :href="roomTypesUrl"><v-icon>room_preferences</v-icon> Room Types</v-btn>

                            <v-btn v-if="isTailormadeTour" class="mt-1" block :href="tripsUrl"><v-icon>room_preferences</v-icon> Trips</v-btn>

                            <v-btn v-if="isTailormadeTour" class="mt-1" block :href="specialExperiencesUrl"><v-icon>star</v-icon> Special Experiences</v-btn>

                            <v-btn v-if="isTailormadeTour" class="mt-1" block :href="destinationsOfferedUrl"><v-icon>place</v-icon> Destinations Offered</v-btn>

                            <v-btn v-if="!isTailormadeTour"class="mt-1" block :href="rateTypesUrl"><v-icon>price_change</v-icon> Rate Types</v-btn>

                            <v-btn class="mt-1" block disabled :href="rateExtrasUrl"><v-icon>add_box</v-icon> Rate Extras</v-btn>

                            <v-btn class="mt-1" block :href="additionalFeesUrl"><v-icon>attach_money</v-icon> Additional Fees</v-btn>

                            <v-btn class="mt-1" block disabled :href="longTermOverviewUrl"><v-icon>calendar_view_month</v-icon> Dashboard</v-btn>

                            <v-btn v-if="!isTailormadeTour"class="mt-1" block :href="dailyPlannerUrl"><v-icon>edit_calendar</v-icon> Daily Planner</v-btn>

                            <v-btn v-if="!isTailormadeTour"class="mt-1" block :href="batchLoaderUrl"><v-icon>upload_file</v-icon> Batch Loader</v-btn>

                            <v-btn v-if="!isTailormadeTour"class="mt-1" block :href="cloneRateDatesUrl"><v-icon>content_copy</v-icon> Clone Historic Rates</v-btn>

                            <v-btn v-if="!isTailormadeTour"class="mt-1" block :href="icalFeedsUrl"><v-icon>calendar_today</v-icon> Incoming iCalendar Feeds</v-btn>

                            <v-btn class="mt-1" block disabled :href="specialOffersUrl"><v-icon>star</v-icon> Special Offers</v-btn>

                            <v-btn class="mt-1" block disabled :href="changeLogUrl"><v-icon>history</v-icon> Change Log</v-btn>

                            <v-btn v-if="!isTailormadeTour"class="mt-1" block disabled :href="rateSummaryUrl"><v-icon>summarize</v-icon> Rate Summary</v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card> 
    </v-col>
</template>

<script>
    /**
     * Display buttons linking through to a hotels' pages
     *
     * @note this is only valid if the hotel is actually bookable in some way, otherwise
     * if the hotel is just a skeletal record for the purposes of trips or other admin
     * then the component ought not display and take up valuable screen space which other
     * relevant panels will need
     */
    export default {
        props:['pageid', 'results'],

        data: function() {
            return {
                tripsUrl: '',
                hotel: {},
                specialExperiencesUrl: '',
                destinationsOfferedUrl: '',
                batchLoaderUrl: '',
                changeLogUrl: '',
                cloneRateDatesUrl: '',
                dailyPlannerUrl: '',
                longTermOverviewUrl: '',
                rateExtrasUrl: '',
                additionalFeesUrl: '',
                rateSummaryUrl: '',
                rateTypesUrl: '',
                roomTypesUrl: '',
                icalFeedsUrl: '',
                isTailormadeTour: false,
                specialOffersUrl: ''
            }
        },

        /**
         * Perform the following actions on startup
         */
        mounted: function()
        {
            this.loadHotel();

            // Extract the hotel ID from the result set passed into this panel from the dashboard
            var hotelKey = this.results.data[0].hotel_key;
            this.batchLoaderUrl = "/hotels/" + hotelKey + '/batch-loader';
            this.tripsUrl = "/hotels/" + hotelKey + '/trips/list';
            this.specialExperiencesUrl = "/hotels/" + hotelKey + '/operator-special-experiences';
            this.destinationsOfferedUrl = "/hotels/" + hotelKey + '/operator-destinations-offered';
            this.changeLogUrl = '';
            this.cloneRateDatesUrl = "/hotels/" + hotelKey + '/clone-rate-dates';
            this.dailyPlannerUrl = "/hotels/" + hotelKey + '/daily-planner';
            this.longTermOverviewUrl = '';
            this.rateExtrasUrl = '/hotels/' + hotelKey + '/rate-extras';
            this.additionalFeesUrl = '/hotels/' + hotelKey + '/additional-fees/list';
            this.rateSummaryUrl = '';
            this.rateTypesUrl = "/hotels/" + hotelKey + "/rate-types/list";
            this.roomTypesUrl = "/hotels/" + hotelKey + "/room-types/list";
            this.specialOffersUrl = '/hotels/' + hotelKey + '/special-offers/list';
            this.icalFeedsUrl = '/hotels/' + hotelKey + '/ical-feeds/list';
            this.isTailormadeTour = this.results.data[0].is_tailormade_tour == 1;
        },

        methods: {

            loadHotel: function(){
                try {
                    // Extract the hotel ID from the result set passed into this panel from the dashboard
                    var hotelKey = this.results.data[0].hotel_key;

                    axios.get('/api/hotel/' + hotelKey + '/summary-information')
                        .then(function(response){
                            this.hotel = response.data.hotel;
                            this.loading = false;
                        }.bind(this));
                    }
                catch(exception){
                    console.log(exception);
                    this.hasProblem = true;
                }
            },

        },

        computed: {}
    }
</script>
<style>
    .major-icon {
        font-size: 5rem;
    }
</style>

